import React from "react"
import { colors } from "@/aena/styles"
import { TouchableOpacity, View, Text } from "react-native"

interface SwitchSelectorProps<O1 extends string, O2 extends string> {
  option1: O1
  option2: O2
  selectedType: O1 | O2
  onTypeChange: (type: O1 | O2) => void
  tOption1: string
  tOption2: string
}

function SwitchSelector<O1 extends string, O2 extends string>({
  option1,
  option2,
  selectedType,
  onTypeChange,
  tOption1,
  tOption2,
}: SwitchSelectorProps<O1, O2>) {
  return (
    <View
      style={{
        flexDirection: "row",
        backgroundColor: colors.grisClaro,
        borderRadius: 8,
        padding: 4,
        marginBottom: 16,
      }}
    >
      <TouchableOpacity
        style={{
          flex: 1,
          paddingVertical: 12,
          paddingHorizontal: 16,
          borderRadius: 6,
          borderWidth: 2,
          borderColor:
            selectedType === option1 ? colors.aenaVerde : "transparent",
          backgroundColor:
            selectedType === option1 ? colors.grisMedio : "transparent",
          alignItems: "center",
          justifyContent: "center",
        }}
        onPress={() => onTypeChange(option1)}
        activeOpacity={0.7}
      >
        <Text>{tOption1}</Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={{
          flex: 1,
          paddingVertical: 12,
          paddingHorizontal: 16,
          borderRadius: 6,
          borderWidth: 2,
          borderColor:
            selectedType === option2 ? colors.aenaVerde : "transparent",
          backgroundColor:
            selectedType === option2 ? colors.grisMedio : "transparent",
          alignItems: "center",
          justifyContent: "center",
        }}
        onPress={() => onTypeChange(option2)}
        activeOpacity={0.7}
      >
        <Text>{tOption2}</Text>
      </TouchableOpacity>
    </View>
  )
}

export { SwitchSelector }